module.exports = __webpack_public_path__ + "static/media/Hoquiam Logo.34aca99f.png";